"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  z-index: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  margin: -32px 0 -16px 0; /* FIXME: \n    Ugly fix to override Heading style created by CardHeader\n    disableTypography or titleTypographyProps doesn't works\n  */\n  .material-icons {\n    color: ", ";\n    position: absolute;\n    top: 8px;\n    left: 8px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 8px 38px 14px 38px;\n  border: 2px solid ", ";\n  background-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Card = (0, _styledComponents.default)(_core.Card)(_templateObject());
var CardHeader = (0, _styledComponents.default)(_core.CardHeader)(_templateObject2(), function (props) {
  return props.theme.palette[props.color].main;
}, function (props) {
  return props.theme.palette.getLighterColor(props.theme.palette[props.color].main);
});
var Title = (0, _styledComponents.default)(_Typography.default)(_templateObject3(), function (props) {
  return props.theme.typography.fontWeightBold;
}, function (props) {
  return props.theme.palette.getDarkerColor(props.theme.palette[props.color].main);
}, function (props) {
  return props.theme.palette.getDarkerColor(props.theme.palette[props.color].main);
});
var Subheader = (0, _styledComponents.default)(_Typography.default)(_templateObject4(), function (props) {
  return props.theme.palette.getDarkerColor(props.theme.palette[props.color].main);
});
var StyledIconButton = (0, _styledComponents.default)(_IconButton.default)(_templateObject5(), function (props) {
  return props.theme.typography.fontWeightBold;
}, function (props) {
  return props.theme.palette.getDarkerColor(props.theme.palette[props.color].main);
});

var getIconName = function getIconName(color) {
  switch (color) {
    case 'primary':
      return 'help_outline';

    case 'warning':
      return 'error_outline';

    case 'error':
      return 'block';

    case 'success':
      return 'check_circle_outline';

    default:
      return 'help_outline';
  }
};

var BubbleMessage = function BubbleMessage(_ref) {
  var children = _ref.children,
      title = _ref.title,
      content = _ref.content,
      color = _ref.color,
      canClose = _ref.canClose,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["children", "title", "content", "color", "canClose", "onClose"]);

  return _react.default.createElement(Card, props, canClose && _react.default.createElement(StyledIconButton, {
    size: "small",
    color: color,
    "aria-label": "Close",
    onClick: onClose
  }, _react.default.createElement(_Icon.default, {
    name: "close"
  })), _react.default.createElement(CardHeader, {
    color: color,
    title: _react.default.createElement(Title, {
      color: color,
      variant: "subtitle1"
    }, _react.default.createElement(_Icon.default, {
      name: getIconName(color),
      color: color
    }), title),
    subheader: _react.default.createElement(Subheader, {
      variant: "body2",
      color: color
    }, content)
  }), children);
};

BubbleMessage.defaultProps = {
  children: '',
  content: '',
  color: 'primary',
  canClose: true,
  onClose: null
};
var _default = BubbleMessage;
exports.default = _default;